import { useJobCountsStore } from '@store/jobCounts';

export function useJobCounts() {
    const jobCountsStore = useJobCountsStore();

    onMounted(async () => {
        await jobCountsStore.fetchCounts();
        await jobCountsStore.startListener();
    });

    onUnmounted(async () => {
        await jobCountsStore.stopListener();
    });

    return {
        newLeadsCount: computed(() => jobCountsStore.getNewLeadsCount),
        pendingJobsCount: computed(() => jobCountsStore.getPendingJobsCount),
        isFetching: computed(() => jobCountsStore.getIsFetching),
        error: computed(() => jobCountsStore.getError),
        refetch: () => jobCountsStore.fetchCounts(),
    };
}
